/* eslint-disable import/no-default-export */
export default {
  tabTitle: 'Monitor by Recruiters',
  only: 'ONLY',
  filter: {
    selectAll: 'Select All',
    reset: 'Reset',
    apply: 'Apply',
    only: 'Only',
    location: {
      label: 'Locations',
      all: 'All Locations',
      search: 'Search Locations...',
    },
    position: {
      open: 'Open Positions',
      closed: 'Closed Positions',
      archived: 'Archived Positions',
    },
    jobs: {
      label: 'Jobs',
      all: 'All Jobs',
      search: 'Search Jobs...',
    },
    province: {
      label: 'Provinces/States',
      all: 'All Provinces/States',
      search: 'Search Provinces/States...',
    },
    city: {
      label: 'Cities',
      all: 'All Cities',
      search: 'Search Cities...',
    },
    district: {
      label: 'Groups',
      all: 'All Groups',
      search: 'Search Groups...',
    },
  },
  recruiterSelect: {
    title: 'Recruiters',
    total: '{{count}} Total',
    search: 'Search Recruiters',
    selectAll: 'Select All Recruiters',
    apply: 'Apply',
    notFound: 'No Recruiters Found',
  },
  positions: {
    title: 'Positions by Location & Type',
    tableHeader: {
      location: 'Location & Position',
      province: 'Province/State',
      city: 'City',
      following: 'Following',
      watching: 'Watching',
      none: 'None',
      sort: {
        label: 'Sort by:',
        options: {
          Location: 'Location',
          Followed: 'Followed',
          Unfollowed: 'Unfollowed',
          Watched: 'Watched',
          Unwatched: 'Unwatched',
        },
      },
    },
    row: {
      stats: {
        following: 'Following',
        watching: 'Watching',
        none: 'None',
      },
    },
    emptyData: 'No data to display for the selected filter.',
  },
  pagination: {
    show: 'Showing',
    info: 'of {{total}} Results',
  },
  positionRecruiters: {
    searchPlaceholder: 'Search by Recruiters',
    filter: {
      // placeholder: 'All Types',
      all: 'All Types',
      following: 'Following',
      watching: 'Watching',
      none: 'None',
    },
    count: {
      following: 'Following:',
      watching: 'Watching:',
      count: 'Recruiter',
      counts: 'Recruiters',
    },
    actions: {
      followed: 'Followed',
      watched: 'Watched',
      none: 'None',
    },
  },

  bulk: {
    actionButton: 'Bulk Assign',
    actionInProgress: 'Assigning',
    cancelAction: 'Exit Bulk Assign',
    progressDialog: {
      header: 'Bulk Update in Progress',
      bodyText1: `Your bulk assign changes are underway. This process can take `,
      bodyText2: `up to 24 hours`,
      bodyText3: `. Until this update is complete, you will not be able to perform an additional update.`,
      button: 'OK',
    },
    recruiterSelectToastMessage: 'Select at least one recruiter',
    positionSelectToastMessage: 'Select at least one position',
    selectionCountInfo: {
      all: 'All',
      message: 'position selected.',
      message_empty: 'No positions selected.',
      message_plural: 'positions selected.',
      allSelected: 'All {{totalCount}} filtered positions are selected.',
      clearSelection: 'Clear Selection',
      selectAll: 'Select all {{totalCount}} filtered positions.',
    },
    selectStatus: {
      placeholder: 'Select status',
      follow: 'Follow',
      watch: 'Watch',
      none: 'None',
    },
    confirmButton: 'Confirm',
    table: {
      location: 'Location',
      position: 'Position',
    },
  },
};
